import { mapGetters, mapActions } from 'vuex';
import TabsContent from '@/components/TabsContent/index.vue';
import breakpoints from '@/helpers/breakpoints';

export default {
  name: 'Subnav',
  components: {
    TabsContent,
  },
  props: {
    tabIds: {
      type: Array,
      required: true,
    },
    tabLabels: {
      type: Array,
      required: true,
    },
    tabContent: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      hashScrollSet: false,
    };
  },
  destroyed() {
    window.removeEventListener('load', this.scrollToTabEvent, false);
  },
  computed: {
    subnavClass() {
      return 'app__subnav';
    },
    ...mapGetters({
      activeTabId: 'getProductActiveTabId',
      hashIsValidTab: 'getHashIsValidProductTab',
      tabsAreSet: 'getProductTabsAreSet',
    }),
  },
  watch: {
    tabsAreSet() {
      if (this.tabsAreSet) this.scrollToHashTab();
    },
  },
  methods: {
    setTabsGaAttr(hash) {
      return `EMS - Content Tab, open, ${hash}`;
    },
    ...mapActions([
      'setProductActiveTabId',
    ]),
    isTabActive(tabId) {
      return {
        'app__subnav__link--active': this.activeTabId === tabId,
      };
    },
    scrollToHashTab() {
      const isNotMobile = window.screen.width >= breakpoints['screen-sm'];

      // Check scroll event hasn't been set,
      // the hash matches a valid tab id
      // is not mobile
      if (!this.hashScrollSet && this.hashIsValidTab && isNotMobile) {
        window.addEventListener('load', this.scrollToTabEvent, false);
        this.hashScrollSet = true;
      }
    },
    scrollToTabEvent() {
      window.scrollTo(0, this.$refs.subnav.offsetTop);
    },
    selectTab(tabId) {
      this.setProductActiveTabId({ tabId });
      // Scroll the container into view
      setTimeout(() => {
        const elToScroll = this.$refs.tabContent.$el;
        if (elToScroll) elToScroll.scrollIntoView(true);
      }, 50);
    },

    tabId(tabId) {
      return tabId.toLowerCase();
    },
  },
};
